export const questions_list_keys = {
  question: {
    field: "question",
    headerName: "Question",
  },
  is_mandatory: {
    field: "is_mandatory",
    headerName: "Is mandatory",
  },
};

export const LISTING_QUESTIONS_FORM_SETTINGS_KEY =
  "listing_queations_form_attributes";

export const LISTING_DEFAULT_QUESTIONS_KEYS = {
  NAME: "custom_form_input_name_label",
  PHONE: "custom_form_input_phone_label",
  EMAIL: "custom_form_input_email_label",
  ENABLE_OTP_VERIFICATION: "enable_otp_verification",
};
